export const formControlSx = {
  margin: '16px 0px 8px 0px',
  borderRadius: '4px',
  padding: '8px',
};

export const radioGroupSx = {
  flexDirection: 'row',
  justifyContent: 'space-between',
};
